import { PRODUCTS } from '../data/products';

const searchRoutes: { keywords: string[]; path: string }[] = [
  { keywords: ['strom', 'gas', 'energie', 'electricity', 'electric'], path: '/strom-gas' },
  { keywords: ['internet', 'dsl', 'kabel', 'cable', 'glasfaser', 'fiber', 'breitband'], path: '/internet-zuhause' },
  { keywords: ['handytarif', 'tarif', 'mobilfunk', 'vertrag', 'mobile', 'plan', 'sim', 'flat', 'allnet'], path: '/produkte/handytarif' },
  { keywords: ['smartphone', 'iphone', 'samsung', 'galaxy', 'pixel', 'handy', 'phone', 'xiaomi', 'redmi'], path: '/produkte/smartphones' },
  { keywords: ['geräte', 'geraete', 'tablet', 'ipad', 'watch', 'uhr', 'kopfhörer', 'kopfhoerer', 'airpods', 'headphone', 'zubehör', 'zubehoer', 'device'], path: '/produkte/geraete' },
  { keywords: ['blog', 'ratgeber', 'tipps', 'guide', 'news', 'artikel'], path: '/blog' },
  { keywords: ['kontakt', 'contact', 'beratung', 'advice', 'anfrage', 'request'], path: '/kontakt' },
  { keywords: ['versicherung', 'insurance', 'haftpflicht', 'hausrat', 'recht'], path: '/produkte/geraete' },
  { keywords: ['tarifrechner', 'calculator', 'rechner', 'vergleich', 'compare'], path: '/angebote/tarif' },
  { keywords: ['voelklingen', 'völkerklingen', 'saarbruecken', 'saarbrücken', 'saarlouis', 'dillingen', 'wadgassen', 'saarland'], path: '/handyvertrag-voelklingen' },
];

export function resolveSearchRoute(query: string): string {
  const q = query.toLowerCase().trim();
  if (!q) return '/produkte/smartphones';

  for (const route of searchRoutes) {
    for (const keyword of route.keywords) {
      if (q.includes(keyword)) {
        return route.path;
      }
    }
  }

  const productMatch = PRODUCTS.find(
    (p) =>
      p.name.toLowerCase().includes(q) ||
      p.description.toLowerCase().includes(q) ||
      p.features.some((f) => f.toLowerCase().includes(q))
  );
  if (productMatch) {
    return `/produkt/${productMatch.id}`;
  }

  return '/produkte/smartphones';
}
